export default "__VITE_ASSET__JR_AlwgR__"